export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const REQUEST_SEARCH_TERM = 'REQUEST_SEARCH_TERM'
export const REQUEST_PAGE_SIZE = 'REQUEST_PAGE_SIZE'
export const REQUEST_SORT_DIR = 'REQUEST_SORT_DIR'
export const REQUEST_ORDER_BY = 'REQUEST_ORDER_BY'
export const REQUEST_FILTER_BY = 'REQUEST_FILTER_BY'
export const SET_REQUESTS = 'SET_REQUESTS'
export const SET_REQUEST = 'SET_REQUEST'
export const SET_NEW_REQUEST = 'SET_NEW_REQUEST'
export const SET_VEHICLEINFO = 'SET_VEHICLEINFO'
export const SET_REQUESTCOUNTS = 'SET_REQUESTCOUNTS'
export const SET_VIN_SUMMARY = 'SET_VIN_SUMMARY'
export const SET_VRM_SUMMARY = 'SET_VRM_SUMMARY'
export const SET_VIN_SUMMARY_UK = 'SET_VIN_SUMMARY_UK'
export const SET_YEARS = 'SET_YEARS'
export const SET_MAKES = 'SET_MAKES'
export const SET_MODELS = 'SET_MODELS'
export const SET_JATO_MAKES = 'SET_JATO_MAKES'
export const SET_JATO_MODELS = 'SET_JATO_MODELS'
export const RESET_JATO_MODELS = 'RESET_JATO_MODELS'
export const SET_JATO_MAKE = 'SET_JATO_MAKE'
export const SET_JATO_MODEL = 'SET_JATO_MODEL'
export const SET_JATO_YEARS = 'SET_JATO_YEARS'
export const SET_SUBMODELS = 'SET_SUBMODELS'
export const SET_ENGINES = 'SET_ENGINES'
export const SET_TRANSMISSIONS = 'SET_TRANSMISSIONS'
export const SET_DRIVETYPES = 'SET_DRIVETYPES'
export const SET_SCANTYPES = 'SET_SCANTYPES'
export const SET_SERVICEELEMENTS = 'SET_SERVICEELEMENTS'
export const SET_REQUESTID = 'SET_REQUESTID'
export const SET_STATUSLIST = 'SET_STATUSLIST'
export const UPDATE_REQUEST_RECORD = 'UPDATE_REQUEST_RECORD'
export const UPDATE_TOTAL_UNREAD = 'UPDATE_TOTAL_UNREAD'
export const UPDATE_UNREAD = 'UPDATE_UNREAD'
export const RESET_REQUEST_UNREAD = 'RESET_REQUEST_UNREAD'
export const UPDATE_REQUEST_UNREAD = 'UPDATE_REQUEST_UNREAD'
export const RESET_MAHLE_API_ERROR_MSG = 'RESET_MAHLE_API_ERROR_MSG'
export const SET_MAHLE_API_ERROR_MSG = 'SET_MAHLE_API_ERROR_MSG'
export const SET_RAGRATINGVEHICLEID = 'SET_RAGRATINGVEHICLEID'
export const SET_MAHLE_TECHPRO_PRODUCTS = 'SET_MAHLE_TECHPRO_PRODUCTS'

export const SESSION_SCANTYPES = 'servicerequests/scantypes'
export const SESSION_SERVICEELEMENTS = 'servicerequests/serviceelements'
export const SESSION_MAHLE_API_ERROR_MSG = 'auth/mahleApiErrorMsg'
export const SESSION_RAGRATINGVEHICLEID = 'servicerequests/ragratingvehicleid'
export const SET_RAG_SERVICEELEMENTS = 'SET_RAG_SERVICEELEMENTS'
export const SET_RAG_DEVICETYPES = 'SET_RAG_DEVICETYPES'



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/types.js